module.exports = __webpack_public_path__ + "static/media/login-background.dcf112ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/login/login-background.jpg
// module id = 1615
// module chunks = 0